import { Skeleton } from '@heroui/react';

import {
  LogLevelCell,
  LogLevelCellSkeleton,
  LogMessageCell,
  LogMessageCellSkeleton,
  PipelineKeyCell,
  PipelineKeyCellSkeleton,
  PipelineNameCell,
  PipelineNameCellSkeleton,
  TimestampCell,
  TimestampCellSkeleton
} from './components';
import type { PipelineLog, PipelineLogOtel } from './types';
// TODO: REMOVE AFTER monitor_migrate_pipeline_logs_to_monitor_service IS PERMANENT - GraphQL type guard import
import { isOTELLog } from './types';

import type { RenderCellProps } from '~/components/Table/Table';

type CellRenderer = {
  // TODO: REMOVE AFTER monitor_migrate_pipeline_logs_to_monitor_service IS PERMANENT - Update to PipelineLogOtel only
  render: (item: PipelineLog | PipelineLogOtel) => JSX.Element;
  skeleton: () => JSX.Element;
};

// TODO: REMOVE AFTER monitor_migrate_pipeline_logs_to_monitor_serviceF IS PERMANENT - Simplify all renderers to use OTEL format only
const CELL_RENDERERS: Record<string, CellRenderer> = {
  logLevel: {
    render: (item: PipelineLog | PipelineLogOtel) => (
      <LogLevelCell
        logLevel={
          isOTELLog(item) ? item.severityText : (item as PipelineLog).logLevel
        }
      />
    ),
    skeleton: () => <LogLevelCellSkeleton />
  },
  pipelineKey: {
    render: (item: PipelineLog | PipelineLogOtel) => (
      <PipelineKeyCell
        pipelineKey={
          isOTELLog(item) ? item.pipelineKey : (item as PipelineLog).pipelineKey
        }
      />
    ),
    skeleton: () => <PipelineKeyCellSkeleton />
  },
  pipelineName: {
    render: (item: PipelineLog | PipelineLogOtel) => (
      <PipelineNameCell
        pipelineName={
          isOTELLog(item)
            ? item.pipelineName
            : (item as PipelineLog).pipelineName
        }
        pipelineVersion={isOTELLog(item) ? item.pipelineVersion : ''}
      />
    ),
    skeleton: () => <PipelineNameCellSkeleton />
  },
  logMessage: {
    render: (item: PipelineLog | PipelineLogOtel) => (
      <LogMessageCell
        logMessage={
          isOTELLog(item) ? item.logMessage : (item as PipelineLog).logMessage
        }
      />
    ),
    skeleton: () => <LogMessageCellSkeleton />
  },
  timestamp: {
    render: (item: PipelineLog | PipelineLogOtel) => (
      <TimestampCell timestamp={item.timestamp} />
    ),
    skeleton: () => <TimestampCellSkeleton />
  }
};

export function renderCell({
  item,
  columnKey,
  isLoading
  // TODO: REMOVE AFTER monitor_migrate_pipeline_logs_to_monitor_service IS PERMANENT - Update type to PipelineLogOtel only
}: RenderCellProps<PipelineLog | PipelineLogOtel>) {
  const renderer = CELL_RENDERERS[columnKey as string];

  if (!renderer) {
    return isLoading ? <Skeleton className='h-4 w-20 rounded' /> : null;
  }

  return isLoading ? renderer.skeleton() : renderer.render(item);
}
